/**
 * Returns the full URL for a given path.
 *
 * @param path - The path to append to the base URL.
 * @returns The full URL for the given path.
 */
export function baseUrl(path = ''): string {
  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? `${process.env.NEXT_PUBLIC_BASE_URL}`
      : 'http://localhost:3000'

  // trim trailing slashes
  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

/**
 * Returns the LEGACY URL for a given path.
 *
 * @param path - The path to append to the base URL.
 * @returns The LEGACY URL for the given path.
 */
export function legacyUrl(path = ''): string {
  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? `${process.env.NEXT_PUBLIC_PLATAFORM_URL}`
      : 'http://localhost/soeducador_legacy/'

  // trim trailing slashes
  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

const ASSETS_BASE_URL = 'https://assets.zamply.com.br'
const ABSOLUTE_URL_REGEX = /^https?:\/\//
const LEADING_SLASH_REGEX = /^\//

/**
 * Resolves an asset path to a full URL.
 *
 * Some endpoints (e.g. order items for extra materials) return the image as a
 * relative path (`zamply/UNITY/products/.../image.png`) instead of a full URL.
 * `next/image` would resolve that against the current origin and 404, so we
 * prefix the assets base. URLs that are already absolute are returned as-is.
 *
 * @param path - The asset path or full URL.
 * @returns The full asset URL, or an empty string when no path is provided.
 */
export function assetUrl(path?: string | null): string {
  if (!path) {
    return ''
  }

  if (ABSOLUTE_URL_REGEX.test(path)) {
    return path
  }

  return `${ASSETS_BASE_URL}/${path.replace(LEADING_SLASH_REGEX, '')}`
}

/**
 * Returns the BFF URL for a given path.
 *
 * @param path - The path to append to the base URL.
 * @returns The BFF URL for the given path.
 */
export function bffUrl(path = ''): string {
  const baseUrl =
    process.env.NODE_ENV === 'production'
      ? `${process.env.NEXT_PUBLIC_BFF_API}`
      : 'http://localhost:3000/api'
  // trim trailing slashes
  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}
